"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const SpursOptions_1 = __importDefault(require("../../../molecules/SpursOptions"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const animation_1 = require("../../../utils/animation");
const bridge_1 = require("@completeanatomy/bridge");
const react_1 = require("react");
const hooks_1 = require("../../../hooks");
function ToolSpursModePage() {
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const { type, size, particleSize } = (0, hooks_1.useSpursOptions)();
    const bridge = (0, bridge_1.useBridge)();
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: type,
            currentOptions: { type: type, sizeIndex: size, size: particleSize },
            senderID: 'tool-spurs',
        });
    }, [bridge, particleSize, size, type]);
    return ((0, jsx_runtime_1.jsx)(ToolsMode_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.tools.spurs.title), clearTitle: (0, i18n_1.Localized)(i18n_1.Strings.tools.spurs.clear), onToggleUI: toggleUIHidden, "data-e2e": 'ToolSpursModePage_ToolsModeTemplate', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolSpursModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsSpursOptionsPanel, { "data-e2e": 'ToolSpursModePage_StyledToolsSpursOptionsPanel' }) }) }));
}
exports.default = ToolSpursModePage;
const StyledToolsSpursOptionsPanel = (0, styled_components_1.default)(SpursOptions_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 50px);

  ${(0, animation_1.SlideDown)('130%')}
`;
